import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import style from "../../assets/jss/disal-main/Layouts/Gerencia";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import EditIcon from "@material-ui/icons/Edit";
import ModalPassword from "../Modal/ModalPassword";
import { makeStyles } from "@material-ui/core/styles";
import { useUsers } from "../../Context/UsersContext";

const useStyles = makeStyles(style);

const User = () => {
  const classes = useStyles();
  const { selected, setSelected, doSave, operatorTypes } = useUsers();

  const [showPassword, setShowPassword] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);

  const [form, setForm] = useState({
    id: "",
    dni: "",
    password: "",
    updatePass: "",
    name: "",
    userType: 0,
    showPassword: false,
    error: { dni: "", password: "", name: "", userType: "" }
  });

  useEffect(() => {
    if (selected) {
      setForm({
        id: selected.operatorId,
        dni: selected.dni,
        password: selected.operatorId !== "" ? "*******" : "",
        name: selected.name,
        userType: selected.operatorTypeId,
        updatePass: "",
        error: { dni: "", password: "", name: "", userType: "" }
      });
    }
  }, [selected]);

  const saveUpdate = (form) => {
    let data;

    if (form.id !== "") {
      data = {
        id: form.id,
        dni: form.dni,
        name: form.name,
        operatorTypeId: form.userType
      };
    } else {
      data = {
        dni: form.dni,
        name: form.name,
        password: form.password,
        operatorTypeId: form.userType
      };
    }

    const error = {};
    if (form.dni === "") {
      error.dni = "*Completar el campo";
    } else {
      error.dni = "";
    }
    if (form.name === "") {
      error.name = "*Completar el campo";
    } else {
      error.name = "";
    }
    if (form.password === "" && form.id !== "") {
      error.password = "*Completar el campo";
    } else {
      error.password = "";
    }

    if (form.userType === 0) {
      error.userType = "*Selecciona una opción";
    } else {
      error.userType = "";
    }

    setForm({ ...form, error });

    const newData = form.updatePass !== "" ? Object.assign(data, { password: form.updatePass }) : data;

    if (
      form.dni !== "" &&
      form.name !== "" &&
      form.password !== "" &&
      form.userType !== 0
    ) {

      doSave(newData);
    }
  }

  const updatePassword = (password) => {
    setForm({ ...form, updatePass: password });
  }

  return (
    <div className={classes.contentForm}>
      <Grid container>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>ID </label>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  disabled
                  name="id"
                  variant="outlined"
                  value={form.id}
                  className={classes.textFielInput + " blocked-id"}
                  onChange={(e) => setForm({ ...form, id: e.target.value })}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>DNI </label>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="dni"
                  variant="outlined"
                  inputProps={{
                    maxLength: 8
                  }}
                  value={form.dni}
                  className={classes.textFielInput}
                  onChange={(e) => setForm({ ...form, dni: e.target.value })}
                />
                <p>
                  {form.error.dni}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>Nombre</label>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="name"
                  variant="outlined"
                  inputProps={{
                    maxLength: 100
                  }}
                  value={form.name}
                  className={classes.textFielInput}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
                <p>
                  {form.error.name}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>Contraseña</label>
              </Grid>
              <Grid item xs={9}>
                {form.id !== "" ? (
                  <FormControl
                    className={
                      classes.formControl + " back-blocked"
                    }
                    variant="outlined"
                  >
                    <OutlinedInput
                      disabled
                      name="password"
                      id="outlined-adornment-password"
                      type={"text"}
                      value={form.password}
                      onChange={(e) => setForm({ ...form, password: e.target.value })}
                      inputProps={{
                        maxLength: 50
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setOpenPassword(true)}
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                          >
                            <EditIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                ) : (
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                  >
                    <OutlinedInput
                      name="password"
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      value={form.password}
                      onChange={(e) => setForm({ ...form, password: e.target.value })}
                      inputProps={{
                        maxLength: 50
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                          >
                            {showPassword ? (<Visibility />) : (<VisibilityOff />)}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                )}
                <p>
                  {form.error.password}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>Tipo de usuario </label>
              </Grid>
              <Grid item xs={9}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Select
                    name="userType"
                    value={form.userType}
                    onChange={(e) => setForm({ ...form, userType: e.target.value })}
                  >
                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                    {operatorTypes.map(res => {
                      return (
                        <MenuItem key={res.id} value={res.id}>{res.description}</MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <p>
                  {form.error.userType}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      <div className={classes.contentButton}>
        <button onClick={() => setSelected(null)}>Cancelar</button>
        <button onClick={() => saveUpdate(form)}>Guardar</button>
      </div>
      <ModalPassword
        open={openPassword}
        handleClose={() => setOpenPassword(false)}
        handleUpdatePass={updatePassword}
      />
    </div>
  );
};

export default User;